import { render, staticRenderFns } from "./btn-primary-active.mpx?vue&type=template&id=fdd03208&isComponent&outputPath=components%2Fbtn-primary-active2110a62a%2Findex"
import script from "./btn-primary-active.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-primary-active2110a62a%2Findex"
export * from "./btn-primary-active.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-primary-active2110a62a%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports